import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider, CssBaseline } from '@mui/material'
import SuperAdmin from './components/SuperAdmin'
import { lightTheme } from './theme'
import './App.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <ThemeProvider theme={lightTheme}>
    <CssBaseline />
    <SuperAdmin />
  </ThemeProvider>
)
